import {
  WebsiteDeploymentStatus,
  WebsiteDomainStatus,
  WebsiteDomainType,
  WebsiteStatus,
} from 'src/api/generated';
import type { ComponentVariant } from 'src/modules/shared/types/component.type';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/** Translation keys of the website publication states. */
export const WEBSITE_STATUS_LABEL_KEYS: Record<WebsiteStatus, TranslationKey> =
  {
    [WebsiteStatus.DRAFT]: 'websites.settings.websiteStatus.draft',
    [WebsiteStatus.PUBLISHING]: 'websites.settings.websiteStatus.publishing',
    [WebsiteStatus.PUBLISHED]: 'websites.settings.websiteStatus.published',
    [WebsiteStatus.FAILED]: 'websites.settings.websiteStatus.failed',
  };

/** Pill colors of the website publication states. */
export const WEBSITE_STATUS_PILL_VARIANTS: Record<
  WebsiteStatus,
  ComponentVariant
> = {
  [WebsiteStatus.DRAFT]: 'neutral',
  [WebsiteStatus.PUBLISHING]: 'info',
  [WebsiteStatus.PUBLISHED]: 'success',
  [WebsiteStatus.FAILED]: 'danger',
};

/** Translation keys of the deployment states. */
export const WEBSITE_DEPLOYMENT_STATUS_LABEL_KEYS: Record<
  WebsiteDeploymentStatus,
  TranslationKey
> = {
  [WebsiteDeploymentStatus.QUEUED]: 'websites.settings.deploymentStatus.queued',
  [WebsiteDeploymentStatus.RUNNING]:
    'websites.settings.deploymentStatus.running',
  [WebsiteDeploymentStatus.SUCCEEDED]:
    'websites.settings.deploymentStatus.succeeded',
  [WebsiteDeploymentStatus.FAILED]: 'websites.settings.deploymentStatus.failed',
};

/** Translation keys of the domain types. */
export const WEBSITE_DOMAIN_TYPE_LABEL_KEYS: Record<
  WebsiteDomainType,
  TranslationKey
> = {
  [WebsiteDomainType.PROVISIONAL]: 'websites.settings.domains.type.provisional',
  [WebsiteDomainType.CUSTOM]: 'websites.settings.domains.type.custom',
};

/** Translation keys of the domain states. */
export const WEBSITE_DOMAIN_STATUS_LABEL_KEYS: Record<
  WebsiteDomainStatus,
  TranslationKey
> = {
  [WebsiteDomainStatus.PROVISIONAL]:
    'websites.settings.domains.status.provisional',
  [WebsiteDomainStatus.PENDING_DNS]:
    'websites.settings.domains.status.pendingDns',
  [WebsiteDomainStatus.PENDING_VALIDATION]:
    'websites.settings.domains.status.pendingValidation',
  [WebsiteDomainStatus.ACTIVE]: 'websites.settings.domains.status.active',
  [WebsiteDomainStatus.ERROR]: 'websites.settings.domains.status.error',
};

/** Translation keys of the custom-domain setup steps, in order. */
export const WEBSITE_DOMAIN_INSTRUCTION_KEYS: readonly TranslationKey[] = [
  'websites.settings.domains.instructions.publish',
  'websites.settings.domains.instructions.addSubdomain',
  'websites.settings.domains.instructions.certificateRecord',
  'websites.settings.domains.instructions.siteRecord',
  'websites.settings.domains.instructions.automaticCheck',
];
